import './assets/styles.css';
import './util/dom.js';
import content from './components/content/component.mjs';

document.body.innerHTML = '';
(async ()=>{
    content.render();
})();
